import { defineStore } from "pinia";
//import {ref} from "vue"

export const useAuthStore = defineStore("auth", {
  state: () => ({
    isAuthenticated: false,
    token: "",
    role: "",
    user: "",
    pass: "",
    invitado: null,
    idEmpresa: "",
  }),
  actions: {
    login(userData, passData, roleData, idData) {
      this.user = userData;
      this.pass = passData;
      this.role = roleData;
      this.idEmpresa = idData;
      this.isAuthenticated = true;
    },
    logout() {
      this.isAuthenticated = false;
      this.role = "";
      this.pass = "";
      this.user = "";
      this.idEmpresa = "";
    },
  },
  persist: true,
});
